import { SET_PROJECTS, SET_PROJECT } from "../actionTypes"

const initialState = {
  projectsObject: {},
  projects: [],
  project: {}
}

const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROJECTS:
      return {
        ...state,
        projects: action.projects.data,
        projectsObject: action.projects
      }
    case SET_PROJECT:
      return {
        ...state,
        project: action.project,
      }
    default:
      return state
  }
}

export default projectsReducer